import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonLabel, IonPage, IonTitle, IonToast, IonToolbar, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { confirmarCadastro, enviarEmail, requestService } from '../../../Utils/Services';
import './ValidarCelular.css';


const ValidarCelular: React.FC = () => {

  const history = useHistory();

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [codigo, setCodigo] = useState("");
  const [botaoAtivo, setBotaoAtivo] = useState(false);
  const [textBotao, setTextBotao] = useState("Validar Número");
  const [confirmation, setConfirmation] = useState<any>();
  const [desabilitarEnviarEmail, setDesabilitarEnviarEmail] = useState(false);

  const inputRef = useRef<any>(null);

  useIonViewDidEnter(() => {
    setDesabilitarEnviarEmail(false);
    // var nome = 'divRecaptcha' + new Date().toLocaleTimeString();
    // let elementToAdd = document.createElement("div");
    // elementToAdd.setAttribute('id', nome);

    // let div = document.getElementById('recaptcha-container');
    // if (div) div.append(elementToAdd);

    // if (!isPlatform('ios')) {
    //   let recpVerify = new RecaptchaVerifier(nome, {
    //     'size': 'invisible',
    //     'callback': (response: any) => {
    //     }
    //   }, authentication);

    //   signInWithPhoneNumber(authentication, '+' + window.localStorage.getItem("telefone"), recpVerify)
    //     .then((confirmationResult) => {
    //       setConfirmation(confirmationResult);
    //       inputRef.current.setFocus();
    //       setBotaoAtivo(true);
    //       console.log(confirmationResult);
    //     }).catch((error) => {
    //       console.log(error);
    //       setTextToast("Não foi possível enviar o SMS.");
    //       setShowToast(true);
    //       setBotaoAtivo(true);
    //       history.goBack();
    //     });
    // }
    // else {
    inputRef.current.setFocus();
    setBotaoAtivo(true);
    //}

    setCodigo("");
    setTextBotao("Validar Número");
  });

  useIonViewWillLeave(() => {
    setShowToast(false);
  });

  const validar = () => {
    inputRef.current.setBlur();
    setBotaoAtivo(false);
    setTextBotao("Aguarde...");

    // if (!isPlatform('ios')) {
    //   confirmation.confirm(codigo).then((result: any) => {
    //     console.log(result);
    //     const user = result?.user;

    //     login(user?.accessToken);


    //   }).catch((error: any) => {
    //     console.log(error);
    //     login();
    //   });
    // }
    // else {
    login();
    //}




  }

  function login(accessToken?: any) {



    const objectRequest = {
      cpf: window.localStorage.getItem("telefone"), // window.localStorage.getItem("telefone"),
      telefone: window.localStorage.getItem("telefone"),
      otp: parseInt(codigo),
      chaveContato: window.localStorage.getItem("chaveContato")?.toString() || "0",
      accessToken: accessToken
    }

    requestService(
      confirmarCadastro.url,
      {
        credentials: "include",
        method: confirmarCadastro.method,
        headers: [
          ["token", window.localStorage.getItem("token") || ""],
          ["perfil", window.localStorage.getItem("perfil") || ""],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        body: JSON.stringify(objectRequest)
      },
      history,
      (response: any) => {
        //        window.localStorage.clear();        
        window.localStorage.setItem("logado", "true");
        window.localStorage.setItem("mapaGoogle", response.mapaGoogle);
        if (response.placas) {
          window.localStorage.setItem("carros", JSON.stringify(response.placas));
          if (response.placas && response.placas[0]) {
            window.localStorage.setItem("veiculo", response.placas[0].toString());
          }
        }
        history.push("/cliente/inicio");
      },
      (error: any) => {
        setTextToast("Token invalido");
        setShowToast(true);
        setCodigo("");
        setBotaoAtivo(true);
        setTextBotao("Validar Número");
      }
    );
  }



  const email = () => {

    requestService(
      enviarEmail.url.replace("{cpf}", window.localStorage.getItem("telefone") || ""),
      {
        method: enviarEmail.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        //body: JSON.stringify(objectRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log("response", response.message);
        setTextToast(response.message);
        setShowToast(true);
        setDesabilitarEnviarEmail(true);

      },
      (error: any) => {
        console.log("error", error);
        setTextToast("Ocorreu um erro ao enviar o e-mail");
        setShowToast(true);
      }
    );
  }

  function onChangeCodigo(e: any) {
    e.persist();
    e.preventDefault();
    setCodigo(e.target.value);

    if (e.keyCode === 13) {
      validar();
    }
  }


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>VALIDE SEU CELULAR</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={"ValidarCelular"}>
        <IonLabel className="titulo">Insira o <strong>código</strong> que você irá receber por <strong>SMS</strong> no celular informado:</IonLabel>
        <div className="input">
          <span>Token</span>
          <IonInput ref={(ref) => inputRef.current = ref} type="number" tabIndex={0} maxlength={6} required value={codigo} onKeyUp={onChangeCodigo} onIonInput={(e: any) => setCodigo(e.target.value)} />
        </div>
        <IonButton disabled={!botaoAtivo} onClick={validar}>{textBotao}</IonButton>
        {/* <div id="recaptcha-container"></div> */}
        {/* <IonButton fill='clear' color="tertiary"
          disabled={desabilitarEnviarEmail}
          onClick={() => { email(); }}>Enviar código por email</IonButton> */}
        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />
      </IonContent>
    </IonPage>
  );
};

export default ValidarCelular;
